import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import logo from '../../assets/logo.png';
import '../../App.css';
import './Login.css';

const FEATURES = [
    { icon: 'bi-journal-medical', text: 'Historias clínicas organizadas y seguras' },
    { icon: 'bi-calendar2-check', text: 'Agenda de citas siempre al día' },
    { icon: 'bi-heart-pulse', text: 'Atención cercana y profesional' },
];

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const result = await login(email, password);

            if (result.success) {
                const roleName = result.user.role_details?.name;
                if (roleName === 'SUPER_ADMIN' || result.user.is_superuser) {
                    navigate('/');
                } else {
                    navigate('/clinica/agenda');
                }
            } else {
                setError(result.error);
            }
        } catch (err) {
            console.error('[Login] Error inesperado al iniciar sesión:', err);
            setError('No se pudo conectar con el servidor. Intenta nuevamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="dr-login">
            {/* Panel de marca */}
            <aside className="dr-brand">
                <span className="dr-blob dr-blob-1" />
                <span className="dr-blob dr-blob-2" />
                <span className="dr-blob dr-blob-3" />

                <div className="dr-brand-inner">
                    <img src={logo} alt="Dra. Romina Suárez - Consultorio Médico" className="dr-brand-logo" />
                    <h1 className="dr-brand-title">
                        Tu consultorio, <span>en un solo lugar.</span>
                    </h1>
                    <p className="dr-brand-text">
                        Gestiona pacientes, citas e historias clínicas con la calma y el cuidado que tu práctica merece.
                    </p>
                    <ul className="dr-features">
                        {FEATURES.map((f) => (
                            <li key={f.icon} className="dr-feature">
                                <span className="dr-feature-icon"><i className={`bi ${f.icon}`} /></span>
                                {f.text}
                            </li>
                        ))}
                    </ul>
                </div>
            </aside>

            {/* Panel del formulario */}
            <main className="dr-form-side">
                <div className="dr-card">
                    <img src={logo} alt="Dra. Romina Suárez - Consultorio Médico" className="dr-card-logo" />

                    <span className="dr-eyebrow"><i className="bi bi-shield-lock" /> Acceso seguro</span>
                    <h2 className="dr-title">Bienvenido de nuevo</h2>
                    <p className="dr-subtitle">Ingresa tus credenciales para acceder a DocRomina.</p>

                    {error && (
                        <div className="dr-alert" role="alert">
                            <i className="bi bi-exclamation-circle" />
                            <span>{error}</span>
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="dr-field">
                            <label htmlFor="email" className="dr-label">Correo electrónico</label>
                            <div className="dr-input-wrap">
                                <i className="bi bi-envelope dr-input-icon" />
                                <input
                                    type="email"
                                    id="email"
                                    className="dr-input"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    autoComplete="username"
                                    autoFocus
                                    placeholder="tu@email.com"
                                />
                            </div>
                        </div>

                        <div className="dr-field">
                            <label htmlFor="password" className="dr-label">Contraseña</label>
                            <div className="dr-input-wrap">
                                <i className="bi bi-lock dr-input-icon" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    id="password"
                                    className="dr-input"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    autoComplete="current-password"
                                    placeholder="••••••••"
                                />
                                <button
                                    type="button"
                                    className="dr-toggle"
                                    onClick={() => setShowPassword((v) => !v)}
                                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                    title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                >
                                    <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} />
                                </button>
                            </div>
                        </div>

                        <button type="submit" className="dr-btn" disabled={loading}>
                            {loading ? (
                                <>
                                    <span className="dr-spinner" /> Ingresando...
                                </>
                            ) : (
                                <>
                                    Ingresar <i className="bi bi-arrow-right" />
                                </>
                            )}
                        </button>
                    </form>

                    <div className="dr-secure">
                        <i className="bi bi-person-lock" /> Acceso exclusivo para personal autorizado
                    </div>

                    <div className="dr-footer">
                        © {new Date().getFullYear()} Dra. Romina Suárez · Consultorio Médico
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Login;
